import { makeStyles } from "@material-ui/core";

const useRbInputLabelStyles = makeStyles(({ palette, palette: { type } }) => ({
  root: {
    color: `${palette.grey[type === "dark" ? 400 : 600]} !important`,
    fontSize: "0.85rem",
    minHeight: 16,
  },
  focused: {
    color: `${palette.grey[type === "dark" ? 400 : 600]} !important`,
  },
  error: {
    color: `${palette.grey[type === "dark" ? 400 : 600]} !important`,
  },
  disabled: {
    opacity: 0.6,
  },
  formControl: {
    position: "relative",
    transform: "none",
    marginBottom: 4,
    lineHeight: "normal",
  },
  marginDense: {
    transform: "none",
  },
}));

export default useRbInputLabelStyles;
